module.exports = __webpack_public_path__ + "img/join_1.4fc9f10f.png";